﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="currentColor"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g stroke="none" stroke-width="1" fill-rule="evenodd">
    <path
      d="M1.81188398e-13,12 C1.81188398e-13,16.2871871 2.287187,20.2487113
      6,22.3923048 C9.7128129,24.5358984 14.2871871,24.5358984 18,22.3923048
      C21.712813,20.2487113 24,16.2871871 24,12 C24,7.71281294
      21.712813,3.75128871 18,1.60769516 C14.2871871,-0.535898387
      9.7128129,-0.535898387 6,1.60769516 C2.287187,3.75128871
      1.81188398e-13,7.71281294 1.81188398e-13,12 L1.81188398e-13,12 Z"
      id="Path" />
    <polyline
      id="Path"
      stroke="#FFFFFF"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      points="18 6.999 11 16.499 6 12.499" />
  </g>
</svg>
